import { ALERT_CHANNELS_OPTIONS } from '@/config/dict';

export default {
  AlertChannels: ALERT_CHANNELS_OPTIONS,
  alertReceiverKey: 'alertReceivers',
};
